import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeByIdController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeByIdController.php
* @route '/api/funeral_home/{funeral_home}'
*/
const GetFuneralHomeByIdController = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetFuneralHomeByIdController.url(args, options),
    method: 'get',
})

GetFuneralHomeByIdController.definition = {
    methods: ["get","head"],
    url: '/api/funeral_home/{funeral_home}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeByIdController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeByIdController.php
* @route '/api/funeral_home/{funeral_home}'
*/
GetFuneralHomeByIdController.url = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { funeral_home: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { funeral_home: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            funeral_home: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        funeral_home: typeof args.funeral_home === 'object'
        ? args.funeral_home.id
        : args.funeral_home,
    }

    return GetFuneralHomeByIdController.definition.url
            .replace('{funeral_home}', parsedArgs.funeral_home.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeByIdController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeByIdController.php
* @route '/api/funeral_home/{funeral_home}'
*/
GetFuneralHomeByIdController.get = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetFuneralHomeByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeByIdController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeByIdController.php
* @route '/api/funeral_home/{funeral_home}'
*/
GetFuneralHomeByIdController.head = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetFuneralHomeByIdController.url(args, options),
    method: 'head',
})

export default GetFuneralHomeByIdController